<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced.  * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

<!-- Development Environment Banner -->
<div *ngIf="isDevelopment" class="bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 text-white py-2 px-4 text-center font-bold text-sm shadow-lg z-50 relative">
  <div class="flex items-center justify-center gap-2">
    <svg class="w-5 h-5 animate-pulse" fill="currentColor" viewBox="0 0 20 20">
      <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
    </svg>
    <span>DEVELOPMENT ENVIRONMENT - Not for production use</span>
    <svg class="w-5 h-5 animate-pulse" fill="currentColor" viewBox="0 0 20 20">
      <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
    </svg>
  </div>
</div>

<!-- Navigation -->
<app-navbar></app-navbar>

<!-- Toast Notifications -->
<app-toast></app-toast>

<!-- Main Content -->
<main>
  <router-outlet />
</main>

<!-- Footer -->
<app-footer></app-footer>

<!-- Cookie Banner -->
<app-cookie-banner></app-cookie-banner>
